<template>
    <div class="VacateInfo">
        <div class="VacateInfo_title">
            <div class="VacateInfo_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">请休假情况</span>
            </div>
            <div class="VacateInfo_title_right">
                <!-- <el-button v-if="canEdit" size="mini" @click="addVacateInfo">添加</el-button> -->
            </div>
        </div>
        <el-table :data="displayVacateInfo" border="1px" style="width: 100%" class="VacateInfoList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="name" label="姓名" align="center" />
            <el-table-column prop="workDate" label="参加工作时间" align="center" width="120" />
            <el-table-column prop="workAge" label="工作年限" align="center" width="100" />
            <el-table-column prop="year" label="年度" align="center" width="100" />
            <el-table-column prop="holiday" label="年休假天数" align="center" width="100" />
            <el-table-column prop="useHoliday" label="已休年假天数" align="center" width="100" />
            <el-table-column prop="surplusHoliday" label="剩余年假天数" align="center" width="100" />
            <el-table-column prop="shi" label="请事假天数" align="center" width="100" />
            <el-table-column prop="bing" label="请病假天数" align="center" width="100" />
            <el-table-column prop="hun" label="请婚假天数" align="center" width="100" />
            <el-table-column prop="sang" label="请丧假天数" align="center" width="100" />
            <el-table-column prop="chan" label="请产假/陪产假天数" align="center" width="100" />
            <el-table-column prop="bu" label="请补休假天数" align="center" width="100" />
            <el-table-column prop="hu" label="请护理假天数" align="center" width="100" />
            <el-table-column prop="yu" label="请育儿假天数" align="center" width="100" />
            <el-table-column prop="tan" label="请探亲假天数" align="center" width="100" />
        </el-table>
        <div class="VacateInfoMore">
            <!-- <el-link type="primary" :disabled="allDataLoaded" size="small" icon="el-icon-plus" @click="loadMore">查看更多</el-link> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'VacateInfo',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            displayVacateInfo: [],
            // 加载的条数
            chunkSize: 5,
            // 已经加载的条数
            loadedCount: 3,
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {
        allDataLoaded() {
            return this.loadedCount >= this.vo.passenger.vacateInfo.length
        }
    },
    watch: {},
    created() {
        this.displayVacateInfo = this.vo.passenger.vacateInfo.slice(0, this.loadedCount)
        // this.loadedCount = this.loadedCount
    },
    beforeDestroy() {},
    mounted() {
        this.vo.passenger.vacateInfo
    },
    updated() {},
    methods: {
        loadMore() {
            if (this.allDataLoaded) return

            // 计算应该加载的数据起始位置
            const startIndex = this.loadedCount
            // 计算应该加载的数据结束位置
            const endIndex = Math.min(startIndex + this.chunkSize, this.vo.passenger.vacateInfo.length)

            // 将新的数据追加到显示数组中
            this.displayVacateInfo = [...this.displayVacateInfo, ...this.vo.passenger.vacateInfo.slice(startIndex, endIndex)]

            // 更新已加载的条数
            this.loadedCount = endIndex
        },
        addVacateInfo() {
            this.$http({
                method: 'POST',
                url: '/rsgl/changeInfo/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.changeInfo.push(res.body.vo)
                }
            })
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.changeInfo = this.vo.passenger.changeInfo.filter((item) => item.id !== row.id)
        },
        // 选择部门
        onSelectSuborgCompleted: function (selectedRows, attr) {
            if (attr.name === 'afterDept') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'afterDept', selectedRows[0].name)
                // this.$set(this.vo.passenger.changeInfo[attr.index], 'orgFullId', selectedRows[0].orgFullId)
            } else if (attr.name === 'beforeDept') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'beforeDept', selectedRows[0].name)
                // this.$set(this.vo.passenger.changeInfo[attr.index], 'orgFullId', selectedRows[0].orgFullId)
            }
        },
        // 选择数据列表
        onSelectListpageRowCompleted: function (selectedRows, attr) {
            if (attr.name === 'beforePostRank') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'beforePostRank', selectedRows[0].rankName)
            } else if (attr.name === 'afterPostRank') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'afterPostRank', selectedRows[0].rankName)
            } else if (attr.name === 'beforePost') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'beforePost', selectedRows[0].postName)
            } else if (attr.name === 'afterPost') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'afterPost', selectedRows[0].postName)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.VacateInfo_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
.VacateInfoMore {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
}
</style>
